import { render, staticRenderFns } from "./Termination.vue?vue&type=template&id=397c9e02&scoped=true&"
import script from "./Termination.vue?vue&type=script&lang=js&"
export * from "./Termination.vue?vue&type=script&lang=js&"
import style0 from "./Termination.vue?vue&type=style&index=0&id=397c9e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397c9e02",
  null
  
)

export default component.exports